export type Settings = Record<string, object | string | number | boolean>


const settings: Settings = {}

export default settings